import { SilentRequest } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { activateCompany } from "../../data/companyService";
import { PrimaryButton } from "../../Styles/Styles";
import { ReactivateCompanyRequest } from "../../data/interfaces/ReactivateCompanyRequest";

interface Props {
  reactivatedCompany: ReactivateCompanyRequest;
}

type FormData = {
  reason: string;
};

const ReactivateButton = ({ reactivatedCompany }: Props) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { register, handleSubmit, errors } = useForm<FormData>({
    mode: "onBlur",
  });

  const sendActivateRequest = async (data: FormData) => {
    const account = instance.getAllAccounts()[0];

    const silentRequest: SilentRequest = {
      scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
      account: account,
    };

    const token = await instance.acquireTokenSilent(silentRequest);

    await activateCompany(
      {
        companyId: reactivatedCompany.companyId,
        changedBy: reactivatedCompany.changedBy,
        reason: data.reason,
      },   
      token.accessToken
    );

    navigate("/");
  };

  return (
    <form
      onSubmit={handleSubmit(sendActivateRequest)}
      className="form-horizontal"
    >
      <div className="row align-items-end mb-4">
        <div className="col">
          <label className="form-label">Hubspot Ticket ID</label>
          <input 
            type='number'
            id="reason"
            name="reason"
            className="form-control"
            ref={register({ required: true, minLength: 10 })}
          /> 
        </div>
        <div className="col">
          <PrimaryButton 
            className="btn"
            type="submit"
            style={{ width: "150px", alignSelf: "flex-end"}}
          >
            Reactivate
          </PrimaryButton>
        </div>
        <div className="col">
        </div> 
      </div>

      {errors.reason && errors.reason.type === "required" && (
              <span className="errors">This field is required</span>
            )}
      {errors.reason && errors.reason.type === "minLength" && (
            <span className="errors">Please input a valid ID</span>
          )}
    </form>
  );
};

export default ReactivateButton;
